import axios from "axios";

/**
 * CareLogix™ ORACLE — Phase 27 Public API Client (additive).
 * No auth required for these public endpoints; AdminOne pages use the
 * existing adminOneClient axios instance for protected resources.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;

const http = axios.create({
  baseURL: `${BASE}/api/oracle`,
  timeout: 20_000,
});

export const oraclePhase27Api = {
  // Scoring
  score: (symbol, asset_class = "stocks") =>
    http.get("/score", { params: { symbol, asset_class } }),
  subFactors: () => http.get("/score/sub-factors"),
  batchScore: (items) => http.post("/score/batch", { items }),
  cryptoIntel: (symbol) => http.get("/crypto-intel", { params: { symbol } }),

  // Scanner
  scannerCategories: () => http.get("/scanner/categories"),
  scanner: (type, limit = 12) => http.get("/scanner", { params: { type, limit } }),
  scannerMulti: (types, limit = 8) => http.post("/scanner/multi", { types, limit }),

  // Notification fabric
  notifChannels: () => http.get("/notifications/channels"),
  notifStatus: () => http.get("/notifications/status"),
  notifTestSend: (channel_id, message = "Test ping from CareLogix ORACLE.") =>
    http.post("/notifications/test-send", { channel_id, message }),
};

export default oraclePhase27Api;
